import { Table } from "antd";
import Loading from "../Loading";
import { createStyles } from "antd-style";

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token; // Ant Design class prefix
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
            overflow-y: auto;
            overflow-x: auto;
          }
          ${antCls}-table-body::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          ${antCls}-table-body::-webkit-scrollbar-thumb {
            background-color: #888;
            border-radius: 4px;
          }
          ${antCls}-table-body::-webkit-scrollbar-track {
            background-color: transparent;
          }
        }
      }
    `,
  };
});
function AntdTableCustom({ loading, ...props }) {
    const { styles } = useStyle();
    return (
        <Table
            {...props}
            loading={{ indicator: <div><Loading /></div>, spinning: loading }}
        pagination={false}
        className={styles.customTable}
        />
    )
}

export default AntdTableCustom;